export const PrecisionGame_EN = {
  precisionGame: {
    headline: "Test Your Precision",
    objective: "Can you hit {{objective}} by clicking the button?",
    totalAttempts: "Total Attempts",
    start: "Start",
    stop: "Stop",
    youWon: "You won",
    congrats: "Congratulations! Well done!",
    leaderboard: {
      headline: "Winners",
      none: "No one has hit the leaderboard yet.",
      username: "Username",
      attempts: "Attempts",
    },
    honorable: {
      headline: "Honorable Mentions",
      none: "No one has come close yet!",
    },
    toast: {
      success: "Your result has been added!",
      error: "Error submitting score: ",
    },
  },
};
